import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=20cdfa3e&scoped=true&"
var script = {}
import style0 from "./phone.vue?vue&type=style&index=0&id=20cdfa3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cdfa3e",
  null
  
)

export default component.exports